<template>
  <div id="container">
    <div class="product-status">
      <div class="search-style">
        <el-form :model="queryParams">
          <el-row :gutter="10">
            <el-col :span="6" style="padding-left:0px !important">
              <el-form-item>
                <el-select v-model="queryParams.supplierName" @change="onSelect">
                  <el-option
                    :label="item.name"
                    :value="item.value"
                    v-for="item in quoteDetailList"
                    :key="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                v-if="queryParams.supplierName==='source'||queryParams.supplierName==='createUser'"
              >
                <el-select v-model="params.value" v-if="queryParams.supplierName==='source'">
                  <el-option label="导入" value="导入"></el-option>
                  <el-option label="询价" value="询价"></el-option>
                  <el-option label="API对接" value="API对接"></el-option>
                </el-select>
                <el-select v-model="params.value" v-else>
                  <el-option
                    v-for="(item,index) in addList"
                    :key="index"
                    :label="item.custodianName"
                    :value="item.custodianName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-else>
                <el-input v-model="params.value" placeholder="请输入关键词"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" style="padding-left:10px;">
              <el-form-item>
                <el-button type="primary" @click="onSearch">搜索</el-button>
                <el-button @click="onSearchReset">重置</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-button style="float:right;" @click="onToLead">导入</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="box-table" :style="{height:tableHeight+'px'}">
        <el-table
          :max-height="tableHeight"
          ref="multipleTable"
          :data="quoteDetailTable"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
          border
        >
          <el-table-column prop="suName" label="供应商" show-overflow-tooltip></el-table-column>
          <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
          <el-table-column prop="seriesName" label="系列" show-overflow-tooltip></el-table-column>
          <el-table-column prop="proModel" label="型号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="proName" label="产品名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="proOrdernum" label="订货号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="proUnit" label="最小单位"></el-table-column>
          <el-table-column prop="stockCount" label="库存数量">
            <template slot-scope="scope">{{scope.row.stockCount===null?'0':scope.row.stockCount}}</template>
          </el-table-column>
          <el-table-column prop="proPrice" label="产品面价">
            <template slot-scope="scope">{{scope.row.proPrice | priceFilterNum}}</template>
          </el-table-column>
          <el-table-column prop="supPrice" label="采购单价">
            <template slot-scope="scope">{{scope.row.supPrice | priceFilterNum}}</template>
          </el-table-column>
          <el-table-column prop="extype" label="类型"></el-table-column>
          <el-table-column prop="extime" label="货期"></el-table-column>
          <el-table-column prop="expire" label="价格有效期" width="95px">
            <template slot-scope="scope">{{scope.row.expire | dateFilterD}}</template>
          </el-table-column>
          <el-table-column prop="exstate" label="是否有效">
            <template slot-scope="scope">{{scope.row.exstate===0?'无效':'有效'}}</template>
          </el-table-column>
          <el-table-column prop="source" label="来源"></el-table-column>
          <el-table-column prop="createUser" label="添加人"></el-table-column>
          <el-table-column prop="createDate" label="添加时间" width="130">
            <template slot-scope="scope">{{scope.row.createDate| dateFilterL}}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination" style="height:50px;">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
    <quote-lead-in @onRefresh="getList" ref="quoteLeadInRef"></quote-lead-in>
  </div>
</template>
<script>
import quoteLeadIn from '@/components/leadIn/quoteLeadIn'
import {
  queryBySupplierOfferQuoteCollect,
  queryAllCreateUser
} from '@/api/supplier/supplierManage'
import { quoteDetailList } from './utils/data'
import pagination from '@/components/pagination'

export default {
  components: {
    pagination,
    'quote-lead-in': quoteLeadIn
  },
  data() {
    return {
      queryParams: {
        supplierName: 'suName'
      },
      params: {
        value: ''
      },
      loadingTable: false, // 列表loading
      quoteDetailList: [],
      quoteDetailTable: [],
      total: 0,
      currentPage: 1, // 当前页
      pageSize: 30, // 分页页数
      addList: [],
      tableHeight: window.innerHeight - 315
    }
  },
  watch: {
    queryParams(val) {
      if (!val.column) {
        this.$set(this.queryParams, 'supplierName', 'suName')
      }
    }
  },
  created() {
    this.quoteDetailList = quoteDetailList
    this.getList()
  },
  methods: {
    // 重置
    onSearchReset() {
      this.currentPage = 1 // 当前页
      this.pageSize = 30 // 分页页数
      this.queryParams = {}
      this.params.value = ''
      this.getList()
    },
    // 导入
    onToLead() {
      this.$refs.quoteLeadInRef.onLeadIn(this.$route.query.id)
    },
    // 根据供应商id查看报价明细列表
    getList() {
      this.loadingTable = true
      const params = {
        criteriaVoList: this.$queryParams(this.queryParams, this.params),
        queryPageName: ''
      }
      queryBySupplierOfferQuoteCollect(
        this.$route.query.id,
        this.currentPage,
        this.pageSize,
        params
      )
        .then(res => {
          if (res.data.code === 200) {
            this.quoteDetailTable = res.data.obj.records
            this.total = res.data.obj.total
            this.loadingTable = false
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取添加人
    getQueryAllCreateUser() {
      queryAllCreateUser(this.$route.query.id)
        .then(res => {
          if (res.data.code === 200) {
            this.addList = res.data.obj
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 切换条件清空
    onSelect() {
      if (this.queryParams.supplierName === 'createUser') {
        this.getQueryAllCreateUser()
      }
      this.params.value = ''
    },
    // 搜索
    onSearch() {
      this.currentPage = 1 // 当前页
      this.pageSize = 30 // 分页页数
      this.getList()
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 分页页数
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    // 分页码数
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
